// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FallOutlinedSvg from "@fishx/icons-svg/es/asn/FallOutlined";
import FishxIcon from '../components/FishxIcon';

var FallOutlined = function FallOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FallOutlinedSvg
  }));
};

FallOutlined.displayName = 'FallOutlined';
export default React.forwardRef(FallOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FallOutlined.js
// module id = 2661
// module chunks = 0